<template>
  <article class="page-home px-4">
    <div class="layout-content">
      <!-- banner -->
      <section v-if="hasActionPermission('home_top')" class="module-top">
        <div class="main-banner">
          <a-carousel
            class="banner"
            arrows
            :autoplay="true"
            :autoplaySpeed="3000"
          >
            <template #prevArrow>
              <div class="custom-slick-arrow left">
                <iconpark-icon name="arrow-left"></iconpark-icon>
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow right">
                <iconpark-icon name="arrow-right"></iconpark-icon>
              </div>
            </template>
            <nuxt-link
              v-for="item in normalBanners"
              :key="item.id"
              class="banner"
              :href="item.view_url"
            >
              <Resource
                :src="item.image_url"
                :lazy="false"
                :resource-option="{
                  format: 'webp',
                  resize: {
                    w: 1400,
                    m: 'lfit',
                  },
                }"
                fetchPriority="hight"
                :alt="item.name"
              ></Resource>
            </nuxt-link>
          </a-carousel>
        </div>
        <div class="middle flex flex-col">
          <nuxt-link
            class="tutorial middle-card cursor-pointer"
            :href="oneMinuteLink?.view_url"
            @click="
              () => {
                trackEvent(TRACK_EVENT.CLICK_HOME_TUTORIAL_PAGE_SHOW)
              }
            "
          >
            <div class="title">{{ $t('xin-shou-ru-men') }}</div>
            <div class="sub">
              {{ $t('dai-ni-yi-fen-zhong-kuai-su-shang-shou') }}
            </div>
            <div class="link">{{ $t('kuai-su-shang-shou') }}</div>
            <iconpark-icon class="d1 absolute" name="d-1-1"></iconpark-icon>
            <Resource
              class="d2 absolute"
              :src="getFeUrl(`/youyan-platform/png/home/tip-jc.png`)"
              :resourceOption="{ format: 'webp' }"
            />
          </nuxt-link>
          <nuxt-link
            class="updates middle-card cursor-pointer"
            :to="{ name: PageKey.NEWS }"
            @click="
              () => {
                trackEvent(TRACK_EVENT.CLICK_PAGE_NEWS)
              }
            "
          >
            <div class="title">{{ $t('chan-pin-liang-dian') }}</div>
            <div class="sub">
              {{ $t('dai-ni-le-jie-you-yan-zui-xin-shi-yong-gong-neng') }}
            </div>
            <div class="link">
              {{ $t('li-ji-ti-yan') }}
            </div>
            <iconpark-icon
              class="d1 absolute"
              name="d-2-1"
              :data-title="$t('home-tutorial')"
            ></iconpark-icon>
            <Resource
              class="d2 absolute"
              :src="getFeUrl(`/youyan-platform/png/home/tip-dt.png`)"
              :resourceOption="{ format: 'webp' }"
            />
          </nuxt-link>
        </div>
        <div
          ref="videoCreation"
          class="video-creation cursor-pointer flex justify-center"
        >
          <video ref="videoRef" class="w-full h-full object-cover"></video>
          <Resource
            :src="getFeUrl('/youyan-platform/video/home-video-cover.png')"
            :resource-option="{
              format: 'webp',
              resize: {
                w: 440,
                m: 'lfit',
              },
            }"
            alt="start-bg"
            :lazy="false"
            class="w-full h-full object-cover absolute top-0 left-0"
          />
          <div class="relative link shark-wrap block" @click="handleCreateWork">
            <!-- {{ $t('kai-shi-chuang-zuo') }} -->
            {{ $t('ai-chuang-zuo') }}
          </div>
        </div>
      </section>
      <!-- search -->
      <!-- <section
        v-if="isChinese() && hasActionPermission('home_search')"
        class="module-search section"
      >
        <h2 class="w-full text-center">
          {{ $t('3d-shu-zi-ren-ai-shi-pin-yi-jian-sheng-cheng') }}
        </h2>
        <Search
          ref="searchRef"
          v-model="keyword"
          size="large"
          :type="'normal'"
          :max="8"
          class="w-[800px] mt-[24px] mx-auto"
          :placeholder="$t('qing-shu-ru-ni-gan-xing-qu-de-nei-rong')"
          :showHot="false"
          :area="SEARCH_RECORD_UNIQUE.SITE"
          :source="SOURCE.HOME"
          @search="handleOnSearch"
        >
        </Search>
        <HotKeys
          :area="SEARCH_RECORD_UNIQUE.SITE"
          class="w-[600px]"
          :source="SOURCE.HOME"
          @select="selectTag"
        />
      </section> -->
      <!-- 3D avatar -->
      <section
        v-if="hasActionPermission('home_character')"
        class="module-3d-avatar relative section"
      >
        <ComponentAvatar />
      </section>
      <!-- 灵感中心 -->
      <section
        v-if="
          hasActionPermission('home_scenarios') ||
          hasActionPermission('home_templates')
        "
        class="module-inspiration relative section"
      >
        <ComponentTemplate />
      </section>
    </div>
  </article>
</template>

<script setup lang="ts">
import { useEntryMounted } from './useEntryMounted.ts'
import ComponentAvatar from './avatar.vue'
import ComponentTemplate from './template.vue'
import { PageKey } from '~/constants/page.ts'
import Search from '@/features/searchInput/index.vue'
import HotKeys from '@/features/searchInput/hotKeys.vue'
import { SEARCH_RECORD_UNIQUE } from '~/constants/index.ts'
import { getBanner } from '~/api/module/activityCenter.ts'
import { useCreateWork } from '~/features/createWork/index.tsx'
import { ClientOnly } from '#components'

const { hasActionPermission } = usePageAndActionPermissionData()

const keyword = ref('')
const searchRef = ref()

const router = useRouter()
const userInfo = useUserInfo()

const videoRef = ref<HTMLVideoElement>()
const videoCreation = ref<HTMLDivElement>()
const videoHover = () => {
  if (!videoRef.value) {
    return
  }
  videoRef.value.src = getFeUrl('/youyan-platform/video/home-hover.mp4')
  videoRef.value.loop = false
}
const videoEnded = () => {
  if (!videoRef.value) {
    return
  }
  videoRef.value.src = getFeUrl('/youyan-platform/video/home-loop.mp4')
  videoRef.value.loop = true
}

onMounted(() => {
  if (!videoRef.value || !videoCreation.value) {
    return
  }
  videoRef.value.src = getFeUrl('/youyan-platform/video/home-enter.mp4')
  videoRef.value.crossOrigin = 'anonymous'
  videoRef.value.autoplay = true
  videoRef.value.muted = true
  videoRef.value.addEventListener('ended', videoEnded)
  videoCreation.value.addEventListener('mouseenter', videoHover)
  videoRef.value.play()
})

onUnmounted(() => {
  videoRef.value?.removeEventListener('ended', videoEnded)
  videoCreation.value?.removeEventListener('mouseenter', videoHover)
})

const handleOnSearch = () => {
  router.push({
    name: PageKey.SITE_SEARCH,
    query: {
      keyword: keyword.value,
    },
  })
}

const selectTag = (val: string) => {
  searchRef.value?.editSearch({ search_record: val })
  router.push({
    name: PageKey.SITE_SEARCH,
    query: {
      keyword: val,
    },
  })
}

const handleCreateWork = () => {
  if (!userInfo.value) {
    loginTask.add({
      type: IAfterLoginActionType.CREATE_WORK,
      payload: {},
    })
    navigateTo('/login?redirect=' + encodeURIComponent(location.href))
  } else {
    useCreateWork()
  }
}

provideResourceLocation({
  source: SOURCE.HOME,
})

// banner 的数据
const { data: banners } = useAsyncData(
  async () => {
    const res = await getBanner()
    return res.data
  },
  { lazy: true }
)

const normalBanners = computed(() => {
  return (banners.value || []).filter((item) => item.type === 0)
})

const oneMinuteLink = computed(() => {
  return (banners.value || []).find((item) => item.type === 1)
})

useEntryMounted()
</script>

<style lang="scss" scoped>
.page-home {
  position: relative;
}

.section {
  margin-top: rem(64);
}
.d1 {
  font-size: rem(80);
}
.d2 {
  position: absolute;
  height: rem(42);
  &::before {
    position: absolute;
    content: attr(data-title);
    font-size: 12px;
    color: var(--black-1);
    width: 100%;
    text-align: center;
    transform: translate(rem(-3), rem(-6));
    font-weight: bold;
  }
}
:deep(.ant-carousel .slick-dots-bottom) {
  bottom: rem(20);
}
:deep(.Component__TemplateMasonry .ant-carousel .slick-dots-bottom) {
  bottom: rem(-20);
}
:deep(h2) {
  font-size: rem(18);
  margin-bottom: rem(24);
}
:deep(.ant-carousel .slick-dots button) {
  display: block;
  width: rem(6);
  height: rem(6);
  border-radius: 50%;
  background-color: var(--text-1);
  opacity: 0.2;
}
:deep(.ant-carousel .slick-dots li.slick-active button) {
  background-color: var(--text-1);
  opacity: 0.6;
}
:deep(.ant-carousel .slick-dots li) {
  display: block;
  width: rem(6);
  height: rem(6);
  border-radius: 50%;
}
:deep(.slick-slide) {
  text-align: center;
  overflow: hidden;
}
:deep(.slick-slide h3) {
  color: #fff;
}

.layout-content {
  width: rem(1200);
  margin: 0 auto;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }

  25%,
  75% {
    transform: rotate(-10deg);
  }

  50% {
    transform: rotate(10deg);
  }
}

.module-search {
  h3 {
    font-size: rem(18);
    font-weight: 500;
    line-height: rem(28);
    color: var(--text-1);
    margin: 0;
  }
}

.middle {
  gap: rem(12);
}

.middle-card {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  border-radius: rem(12);
  box-sizing: border-box;
  padding: rem(20);
  flex: 1;

  &.updates {
    .link {
      color: #6962ff;
    }
    .d1 {
      right: rem(12);
      bottom: rem(18);
    }
    .d2 {
      right: rem(20);
      bottom: rem(81);
    }
  }

  &.tutorial {
    .d1 {
      right: rem(11);
      bottom: rem(0);
    }
    .d2 {
      right: rem(20);
      bottom: rem(73);
    }
  }

  &:hover {
    .d2 {
      animation: shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
    .link {
      opacity: 1;
    }
  }

  .title {
    font-size: rem(16);
    color: #fff;
    margin-top: rem(4);
    font-weight: 600;
  }
  .sub {
    margin-top: rem(6);
    font-size: rem(13);
    line-height: rem(18);
    color: rgba($color: #fff, $alpha: 0.8);
    width: 85%;
    z-index: 2;
  }
  .link {
    position: absolute;
    left: rem(20);
    bottom: rem(20);
    width: rem(88);
    height: rem(28);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #437de6;
    font-weight: 600;
    border-radius: rem(16);
    background-color: #fff;
    opacity: 0.6;
    font-size: rem(12);
    transition: opacity 0.3s ease-in-out;
  }
}

.module-top {
  display: grid;
  grid-template-columns: rem(696) rem(260) rem(220);
  gap: 1%;
  min-width: rem(1200);
  margin-top: rem(20);
  width: 100%;
}

/* Main Banner */
.main-banner {
  border-radius: rem(16);
  overflow: hidden;
  position: relative;
  height: rem(300);

  &:deep(img) {
    width: rem(696);
    height: rem(300);
  }

  .custom-slick-arrow {
    z-index: 10;
    display: none !important;
    width: rem(32);
    height: rem(32);
    &.left {
      left: rem(10);
    }
    &.right {
      right: rem(10);
    }
    iconpark-icon {
      font-size: rem(32);
    }
  }

  &:hover {
    .custom-slick-arrow {
      display: flex !important;
    }
  }
}

/* Top-Right Tutorial */
.tutorial {
  background: linear-gradient(111.89deg, #498cff 9.86%, #a8dcff 98.4%);
}

/* Middle-Right Product Updates */
.updates {
  background: linear-gradient(111.89deg, #695bff 9.86%, #e8baff 100%);
}

/* Bottom-Right Video Creation */
.video-creation {
  background-color: #3b2f4f;
  border-radius: rem(12);
  overflow: hidden;
  position: relative;
  .link {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: rem(20);
    width: rem(118);
    height: rem(36);
    font-weight: 600;
    border-radius: rem(20);
    font-size: rem(14);
    overflow: hidden;
    background: linear-gradient(223deg, #ffc5fe -14.44%, #8d8dfb 145.66%);
    color: #1d0944;
  }
}
</style>
